import axios from 'axios';

export async function HandleAddFile(file) {
    const url = `api/crmFileFront/upload/`;
    const query = {
        ownerId: file.ownerId, 
        dealId: file.dealId,
        organizationId: file.orgId,
        personId: file.personId
    }
    const formData = new FormData();
    formData.append('file', file);
    console.log(formData);
    const res = await axios
        .post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: query
        })
        .then(
            (response) => {
                if (response.status === 200) {
                    return { success: true, error: null, data: response.data };
                } else {
                    return { success: false, error: response.data.message, data: null };
                }
            },
            (error) => {
                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
            }
        );

    return res;
}

export async function HandleAddExlFile(file, teacherId) {
    const url = `api/exlFileFront/uploadFile/`;
    const query = {
        teacherId: teacherId,
    }
    const formData = new FormData();
    formData.append('file', file);

    const res = await axios
        .post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: query
        })
        .then(
            (response) => {
                if (response.status === 200) {
                    return { success: true, error: null, data: response.data };
                } else {
                    return { success: false, error: response.data.message, data: null };
                }
            },
            (error) => {
                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
            }
        );

    return res;
}

export async function HandleGetExlFile(teacherId) {
    const url = `api/exlFileFront/getFile/`;

    const query = {
        id: teacherId,
    }

    const res = await axios
        .get(url, {
            params: query
        })
        .then(
            (response) => {
                if (response.status === 200) {
                    return { success: true, error: null, data: response.data };
                } else {
                    return { success: false, error: response.data.message, data: null };
                }
            },
            (error) => {
                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
            }
        );

    return res;
}

export async function HandleRemoveExlFile(fileId) {
    const url = `api/exlFileFront/removeFile/${fileId}`;
    const res = await axios.delete(url).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandleRemoveFile(file) {
    const url = `api/crmFileFront/${file.id}`;

    const data = { fileId: file.id };

    const res = await axios.delete(url).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}
